// @mui
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { List, ListItemButton, ListItemIcon } from '@mui/material';
// theme
import { hideScroll } from '../theme/css';
// hooks
import { useAuthContext } from '../auth/hooks';

// components
import Logo from '../components/logo';
import { NavSectionMini } from '../components/nav-section';
//
import { NAV } from './config-layout';
import { useNavData } from './config-navigation';
import { NavToggleButton } from './_common';
import { useSettingsContext } from '../components/settings';
import Iconify from '../components/iconify';

// ----------------------------------------------------------------------

export default function NavMini() {
  const { logout } = useAuthContext();
  const settings = useSettingsContext()

  const navData = useNavData(settings.files, settings.valid);

  const handleLogout = () => {
    logout();
  };

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_MINI },
      }}
    >
      <NavToggleButton
        sx={{
          top: 22,
          left: NAV.W_MINI - 12,
        }}
      />

      <Stack
        sx={{
          pb: 2,
          height: 1,
          position: 'fixed',
          width: NAV.W_MINI,
          borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
          ...hideScroll.x,
        }}
      >
        <Logo mini sx={{ mx: 'auto', my: 2 }} />

        <NavSectionMini
          data={navData}
          // config={{
          //   currentRole: user?.role || 'admin',
          // }}
        />

        <Box sx={{ flexGrow: 1 }} />

        <List sx={{ px: 0, pb: 2 }}>
          <ListItemButton
            onClick={handleLogout}
            sx={{
              justifyContent: 'center',
              color: 'text.secondary',
              minHeight: 48,
            }}
          >
            <ListItemIcon sx={{ color: 'text.secondary', minWidth: 'auto' }}>
              <Iconify icon="ic:outline-logout" width={24} />
            </ListItemIcon>
          </ListItemButton>
        </List>
      </Stack>
    </Box>
  );
}
